import { fetchWithCache, getCachedData } from "../services/apiService";

export const commentGet = async (property_id, setComments) => {
  const cacheKey = `/api/comment/commentGetClient_${property_id}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached) {
    if (setComments) setComments(cached);
    return cached;
  }

  try {
    const data = await fetchWithCache(
      "/api/comment/commentGet",
      {
        method: "POST",
        body: JSON.stringify({ property_id }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    if (setComments) setComments(data);
    return data;
  } catch (err) {
    return cached || null;
  }
};
